export function summarizeSCBalances(sweepCoin: number, bonusSweepCoin: number) {
  return sweepCoin + bonusSweepCoin;
}
